import _CircularProgress from "@material-ui/core/esm/CircularProgress";
import _Close from "@material-ui/icons/esm/Close";
import _Drawer from "@material-ui/core/esm/Drawer";
import _Badge from "@material-ui/core/esm/Badge";
import _Avatar from "@material-ui/core/esm/Avatar";
import _IconButton from "@material-ui/core/esm/IconButton";
var REACT_ELEMENT_TYPE;

function _jsx(type, props, key, children) { if (!REACT_ELEMENT_TYPE) { REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol["for"] && Symbol["for"]("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = { children: void 0 }; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : "" + key, ref: null, props: props, _owner: null }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React from 'react';
import { useEffect, useState } from 'react';
import { getContactInfo } from "../../../api/requests/contacts";
import { useMessenger } from "../../Messenger";
import { useUsers } from "../hooks/useUsers";
import { useStyles } from "./UserSideDrawerStyles";
import { useErrors } from "../../Errors/hooks/useErrors";

var _ref2 = /*#__PURE__*/_jsx(_Close, {});

var _ref4 = /*#__PURE__*/_jsx(_Close, {});

var _ref5 = /*#__PURE__*/_jsx(_CircularProgress, {
  color: "primary"
});

export const UserSideDrawer = () => {
  const _useMessenger = useMessenger(),
        _useMessenger$userSid = _useMessenger.userSideDrawer,
        visible = _useMessenger$userSid.visible,
        handleHide = _useMessenger$userSid.handleHide,
        _user = _useMessenger$userSid.user;

  const _useUsers = useUsers(),
        connectedUsers = _useUsers.connectedUsers;

  const classes = useStyles();

  const _useErrors = useErrors(),
        handleShowError = _useErrors.handleShowError;

  const _useState = useState(),
        _useState2 = _slicedToArray(_useState, 2),
        user = _useState2[0],
        setUser = _useState2[1];

  useEffect(() => {
    setUser(null);

    if (_user) {
      _asyncToGenerator(function* () {
        try {
          const user = yield getContactInfo(_user.id);
          setUser(user);
        } catch (error) {
          handleHide();
          handleShowError(error.message);
        }
      })();
    }
  }, [_user]);
  return _jsx(_Drawer, {
    anchor: "right",
    open: visible,
    onClose: handleHide
  }, void 0, _jsx("div", {
    className: classes.container
  }, void 0, user ? React.createElement(React.Fragment, null, _jsx(_IconButton, {
    className: classes.closeIcon,
    onClick: handleHide
  }, void 0, _ref2), _jsx("div", {
    className: classes.spacer
  }, void 0, _jsx("span", {
    className: classes.state
  }, void 0, "Estado:", ' ', connectedUsers.contacts?.some(connectedUser => connectedUser.id === user?.id) ? 'Disponible' : 'No disponible')), _jsx("div", {
    className: classes.dataContainer
  }, void 0, _jsx(_Badge, {
    color: "primary",
    badgeContent: " ",
    overlap: "circle",
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'right'
    },
    invisible: !connectedUsers.contacts?.some(_ref3 => {
      let id = _ref3.id;
      return id === user?.id;
    }),
    classes: {
      root: classes.avatarContainer
    }
  }, void 0, _jsx(_Avatar, {
    src: user?.avatar,
    alt: "Activity",
    className: classes.avatar
  })), _jsx("div", {
    className: classes.primaryText
  }, void 0, user?.name), user?.position && _jsx("div", {
    className: "".concat(classes.secondaryText, " ").concat(classes.marginTop)
  }, void 0, user?.position), user?.id && _jsx("div", {
    className: classes.secondaryText
  }, void 0, "ID ", user?.id), user?.email && _jsx("div", {
    className: "".concat(classes.tertiaryText, " ").concat(classes.marginTop)
  }, void 0, "Correo electronico: ", user?.email), user?.description && _jsx("div", {
    className: "".concat(classes.tertiaryText, " ").concat(classes.marginTop)
  }, void 0, user?.description)), _jsx("div", {
    className: classes.spacer
  })) : React.createElement(React.Fragment, null, _jsx(_IconButton, {
    className: classes.closeIcon,
    onClick: handleHide
  }, void 0, _ref4), _jsx("div", {
    className: classes.noUser
  }, void 0, _ref5))));
};